module.exports = __webpack_public_path__ + "media/images/other/login copy-31ff687a44b4986d36f89fabc2e20042.jpg";